export enum EMAIL_BODY_TEXT_FIELD {
  EMPLOYER_NAME = "EMPLOYER_NAME",
  EMPLOYEE_NAME = "EMPLOYEE_NAME",
  ROLE = "ROLE",
  WORKLOAD = "WORKLOAD",
  SALARY = "SALARY",
  BENEFITS = "BENEFITS",
}
